/**
 * @fileoverview VenueSearchcomponent
 *
 * Will implement teh Venue Search functionality
 */

import Data from '../../utils/dom/data';
import Modal from '../Modal';
import SuggestionInput from '../SuggestionInput';
import attachValidation from '../../utils/form-validation';

import SelectorEngine from '../../utils/dom/selector-engine';
import Request from '../../utils/request';
import { getDataFromForm } from '../../utils/misc';

class VenueSearch {
	constructor() {
		this.state = {
			count: 0,
			venues: [],
			existingVenues: [],
			removedVenues: [],
			addedVenues: [],
			currentVenue: null
		}
		this._wrapper = undefined;
		this._venuesWrapper;
		this._suggestion;
		this._suggestionInput;
		this._action;
		this._paymentModal;
		this._paymentCancel;
		this._paymentForm;
		this._fv;
		this._retriveVenue = undefined;
		this._generalError = undefined;
		this._mainLabel = undefined;

		this.initiateSearch();
	}

	initiateSearch() {
		this._wrapper = SelectorEngine.findOne('.lta-venue-search');

		if (this._wrapper !== null) {
			this._retriveVenue = SelectorEngine.findOne('.js-retrive-venues');

			this._venuesWrapper = SelectorEngine.findOne('.lta-venue-search--venues', this._wrapper);
			this._suggestion = SelectorEngine.findOne('.lta-venue-search--search', this._wrapper);
			this._suggestionInput = SelectorEngine.findOne('.lta-text-input', this._suggestion);
			this._action = SelectorEngine.findOne('.lta-venue-search--add', this._wrapper);
			this._paymentModal = new Modal(this._wrapper.querySelector('#venue-search-modal'), {});
			this._paymentForm = SelectorEngine.findOne('#venue-payment', this._wrapper);
			this._paymentCancel = SelectorEngine.findOne('.js-payment-cancel', this._wrapper);
			this._generalError = SelectorEngine.findOne('.lta-venue-search--error', this._wrapper);
			this._mainLabel = SelectorEngine.findOne('.lta-text-input__label', this._wrapper);

			const suggestionInputEl = SelectorEngine.findOne('.lta-autosuggest-input', this._wrapper);
			this.suggestionInput = SuggestionInput.getInstance(suggestionInputEl) || new SuggestionInput(suggestionInputEl);

			if (this._generalError !== null) {
				const generalErrorClose = SelectorEngine.findOne('.js-dismiss-venues-error', this._generalError);
				generalErrorClose.addEventListener('click', () => {
					this._generalError.classList.add('u-hidden');
				});
			}

			this._wrapper.addEventListener('venueSelect', (event) => {
				this.addPaymentInfo(event.detail);
			}, false);

			this._paymentCancel.addEventListener('click', () => {
				this.suggestionInput.clearSelectedResult(this.state.currentVenue.venueId);
				this._paymentModal.hide();
			});

			if (this._retriveVenue !== null) {
				this.loadExistingVenues();
			}

			this._fv = attachValidation(this._paymentForm, {
				paymentMethod: {
					validators: {
						notEmpty: {
							message: "Please select a payment type"
						}
					}
				}
			});

			this._fv.on('core.form.valid', () => {
				const dataObject = getDataFromForm(this._paymentForm);
				this.state.count = this.state.venues.length > 0 ? this.state.venues?.slice(-1)[0].venueClass : this.state.venues.length;
				this.state.count = this.state.count + 1;

				const updatedVenueDetails = Object.assign({}, this.state.currentVenue, { paymentType: dataObject.paymentMethod, venueClass: this.state.count });
				this.state.currentVenue = updatedVenueDetails;
				this.state.addedVenues.push(updatedVenueDetails);

				this.addVenue();
				const removeCtas = SelectorEngine.find('.lta-venue-search--remove', this._venuesWrapper);
				this._suggestion.classList.add('u-hidden');
				this._action.classList.remove('u-hidden');
				this._paymentModal.hide();
				this._fv.resetForm(true);
				removeCtas[removeCtas.length - 1].focus();
			});

			const addVenueButton = this._wrapper.querySelector('.js-add-venue');
			addVenueButton.addEventListener('click', () => {
				this._suggestion.classList.remove('u-hidden');
				this._suggestionInput.value = '';
				this._suggestionInput.focus();
				this._action.classList.add('u-hidden');
			})
		}

	}

	async loadExistingVenues() {
		this._suggestion.classList.add('u-hidden');
		this._action.classList.remove('u-hidden');

		const existingVenues = await Request.get('/api/account/venues')
			.catch(() => {
				this._generalError.classList.remove('u-hidden');
				const generalErrorClose = SelectorEngine.findOne('.js-dismiss-venues-error', this._generalError);
				generalErrorClose.focus();
			});

		if (existingVenues.venueDetails.length > 0) {
			existingVenues.venueDetails.forEach((venue) => {
				this.state.count = this.state.count + 1;
				const updatedVenue = Object.assign({}, venue, { venueClass: this.state.count });
				this.state.venues.push(updatedVenue);
				this.state.existingVenues.push(updatedVenue);
				this.addVenue(updatedVenue);
			});
		}
	}

	addPaymentInfo(venue) {
		this.state.currentVenue = venue;
		this._paymentModal.show();
	}

	addVenue(venue = this.state.currentVenue) {
		const venueTemplate = SelectorEngine.findOne('.lta-venue--template', this._wrapper);
		const locationCard = SelectorEngine.findOne('.lta-location-card', venueTemplate);
		const venueWrapper = locationCard.cloneNode(true);
		venueWrapper.setAttribute('id', `venue-${venue.venueClass}`);
		const contentWrapper = SelectorEngine.findOne('.lta-location-card--content', venueWrapper);
		const [wrapperForm] = SelectorEngine.find('form', this._venuesWrapper);

		const removeCta = SelectorEngine.findOne('.lta-venue-search--remove', venueWrapper);
		removeCta.dataset.venueid = venue.venueClass;

		const paragraphBold = document.createElement('b');
		const venueName = document.createTextNode(venue.venueName);
		const venueStreet = document.createTextNode(venue.venueAddress.street);
		const venueCity = document.createTextNode(venue.venueAddress.city);
		const venuePostcode = document.createTextNode(venue.venueAddress.postCode);
		paragraphBold.append(venueName);
		const venueText = document.createElement('p');
		venueText.classList.add('width-100');
		venueText.append(paragraphBold);
		venueText.append(document.createElement('br'));
		venueText.append(venueStreet);
		venueText.append(document.createElement('br'));
		venueText.append(venueCity);
		venueText.append(document.createElement('br'));
		venueText.append(venuePostcode);

		contentWrapper.append(venueText);

		const payment = document.createElement('p');
		payment.classList.add('u-mt-2');
		const paymentText = document.createTextNode(`Payment type: ${venue.paymentType}`);
		payment.append(paymentText);

		contentWrapper.append(payment);

		const hiddenInput = (name, value) => {
			const input = document.createElement('input');
			input.setAttribute('type', 'text');
			input.classList.add('u-hidden');
			input.setAttribute('name', name);
			input.setAttribute('value', value);
			return input;
		}

		const venueIdInput = hiddenInput(`venueDetails[${this.state.venues.length}][venueId]`, venue.venueId);
		const paymentInput = hiddenInput(`venueDetails[${this.state.venues.length}][paymentType]`, venue.paymentType);

		contentWrapper.append(venueIdInput);
		contentWrapper.append(paymentInput);

		wrapperForm.append(venueWrapper);
		this._mainLabel.classList.remove('u-hidden');

		const venueRemoveButton = SelectorEngine.findOne('.lta-venue-search--remove', venueWrapper);
		this.state.venues.push(venue);

		venueIdInput.dispatchEvent(this.createEvent());
		this.state.currentVenue = null;
		venueRemoveButton.addEventListener('click', (event) => {
			this.removeVenue(event);
		})
	}

	createEvent() {
		const formEvent = new CustomEvent('change', {
			bubbles: true,
			detail: {
				name: 'venueDetails',
				values: this.state.venues,
				add: this.state.addedVenues,
				remove: this.state.removedVenues
			}
		});
		return formEvent;
	}

	removeVenue(event) {
		const idToRemove = event.target.dataset.venueid;
		const venueToRemove = SelectorEngine.findOne(`#venue-${idToRemove}`, this._venuesWrapper);
		const [input] = venueToRemove.querySelectorAll('input');
		const [removedVenue] = this.state.venues.filter((venue) => venue.venueClass === Number(idToRemove));
		const remainingVenues = this.state.venues.filter((venue) => venue.venueClass !== removedVenue.venueClass);
		this.state.venues = remainingVenues;
		const [isAddedVenue] = this.state.addedVenues.filter((venue) => venue.venueClass === removedVenue.venueClass);
		if (isAddedVenue){
			this.state.addedVenues = this.state.addedVenues.filter((venue) => venue.venueClass !== Number(idToRemove));
		} else {
			this.state.removedVenues.push(removedVenue);
		}

		input.dispatchEvent(this.createEvent());
		venueToRemove.remove();

		this.suggestionInput.clearSelectedResult(removedVenue.venueId);

		if (this.state.venues.length === 0) {
			this._suggestion.classList.remove('u-hidden');
			this._suggestionInput.value = '';
			this._suggestionInput.focus();
			this._mainLabel.classList.add('u-hidden');
			if (this._retriveVenue !== null) {
				this._suggestion.classList.add('u-hidden');
				this._action.classList.remove('u-hidden');
			} else {
				this._action.classList.add('u-hidden');
			}
		}
	}
}

const globalVenueSearch = new VenueSearch();

export default globalVenueSearch;
